import { render, staticRenderFns } from "./UserArr.vue?vue&type=template&id=08caf1d0"
import script from "./UserArr.vue?vue&type=script&lang=js"
export * from "./UserArr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports